import React from 'react'

function Links() {
  return (
    <div>

      <section className="links-container">

        <a className="btn btn--odd btn--animated" target="_blank" href="https://tired-template.netlify.app">
          Client Template</a>
          <br />

        <a className="btn btn--animated" target="_blank" href="https://zachpower.onrender.com">
          Zach's Portfolio</a>
          <br />

        <a className="btn btn--animated" target="_blank" href="https://developedbydrewford.netlify.app">
          Drew's Portfolio</a>
          <br />

      </section>

    </div>
  )
}

export default Links